import { render, staticRenderFns } from "./itemAvailabilities.vue?vue&type=template&id=db35ed74"
import script from "./itemAvailabilities.vue?vue&type=script&lang=ts"
export * from "./itemAvailabilities.vue?vue&type=script&lang=ts"
import style0 from "./itemDetails.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./acquisitionViews.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports